import { render, staticRenderFns } from "./DevolucaoForm.vue?vue&type=template&id=2129c2a5&scoped=true&"
import script from "./DevolucaoForm.vue?vue&type=script&lang=js&"
export * from "./DevolucaoForm.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoForm.vue?vue&type=style&index=0&id=2129c2a5&scoped=true&lang=css&"
import style1 from "./DevolucaoForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129c2a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
